const genericHealthQuestions = [
	`REQUIRED: Have you been diagnosed by a physician with a terminal illness or are you receiving hospice care?`,
	`Are you confined to a bed, hospitalized, scheduled for surgery requiring an overnight hospital stay, or receiving skilled nursing care;

	OR within the past two (2) years, have you had, been diagnosed with, or received treatment (including medication) by a medical professional for any of the following:
	stroke, organ transplant, cancer (other than skin), immune system disorder;

	OR within the past one (1) year, have you had, been diagnosed with, or received treatment (including medication) by a medical professional for any of the following:
	COPD (Chronic Obstructive Pulmonary Disease), emphysema, chronic heart disease, congestive heart failure, cirrhosis of the liver, kidney/renal failure, kidney dialysis, Alzheimer's disease, ALS (Amyotrophic Lateral Sclerosis), or amputation due to disease?`,
]

// Helper to add extra condition onto the second question
function withAdditionalClause(additionalClause: string): string[] {
	const [q1, q2] = genericHealthQuestions
	return [
		q1,
		`${q2}

OR ${additionalClause}`,
	]
}

const healthQuestions: Record<string, string[]> = {
	AK: genericHealthQuestions,
	AL: genericHealthQuestions,
	AR: genericHealthQuestions,
	AZ: genericHealthQuestions,
	CA: genericHealthQuestions,
	CO: genericHealthQuestions,
	CT: genericHealthQuestions,
	DE: genericHealthQuestions,
	FL: withAdditionalClause(
		`has any Proposed Insured ever tested positive for exposure to HIV infection or been diagnosed as having ARC or AIDS caused by the HIV infection or other sickness or condition derived from such infection?`
	),
	GA: genericHealthQuestions,
	HI: genericHealthQuestions,
	IA: genericHealthQuestions,
	ID: genericHealthQuestions,
	IL: genericHealthQuestions,
	IN: [
		// IN modifies only the first question to add "Yes / No"
		`REQUIRED: Have you been diagnosed by a physician with a terminal illness or are you receiving hospice care? Yes / No`,
		genericHealthQuestions[1],
	],
	KS: genericHealthQuestions,
	KY: genericHealthQuestions,
	LA: genericHealthQuestions,
	MA: withAdditionalClause(
		`have you been diagnosed by a physician as having, or have you tested positive for, Acquired Immune Deficiency Syndrome (AIDS), Human Immunodeficiency Virus (HIV), or Aids Related Complex (ARC)? (Note: Any AIDS/HIV test results received at an anonymous counseling/testing site need not be disclosed.)`
	),
	MD: withAdditionalClause(
		`has any Proposed Insured ever tested positive for exposure to HIV infection or been diagnosed as having ARC or AIDS caused by the HIV infection or other sickness or condition derived from such infection?`
	),
	ME: genericHealthQuestions,
	MI: genericHealthQuestions,
	MN: [
		// MN removes "including medication" and "any of the following"
		`REQUIRED: Have you been diagnosed by a physician with a terminal illness or are you receiving hospice care?`,
		`Are you confined to a bed, hospitalized, scheduled for surgery requiring an overnight hospital stay, or receiving skilled nursing care;

		OR within the past two (2) years, have you had, been diagnosed with, or received treatment by a medical professional for stroke, organ transplant, cancer (other than skin), or immune system disorder;

		OR within the past one (1) year, have you had, been diagnosed with, or received treatment by a medical professional for COPD, emphysema, chronic heart disease, congestive heart failure, cirrhosis of the liver, kidney/renal failure, kidney dialysis, Alzheimer's disease, ALS (Amyotrophic Lateral Sclerosis), or amputation due to disease?`,
	],
	MO: genericHealthQuestions,
	MS: genericHealthQuestions,
	MT: genericHealthQuestions,
	NC: genericHealthQuestions,
	ND: genericHealthQuestions,
	NE: genericHealthQuestions,
	NH: genericHealthQuestions,
	NJ: [
		// NJ combines all health history into a single large question, adds substance abuse and diabetic coma
		`Are you currently on oxygen, hospitalized, receiving hospice care, or confined to a nursing home or long-term care facility; or during the past two years have you been advised by a medical professional to have surgery not yet performed; or have you been treated by a medical professional for any of the following:

		Congestive Heart Failure, Heart Disease, Stroke, Cancer (other than skin), Immune System Disorder, Cirrhosis of the Liver, Drug or Alcohol Dependency, Kidney failure (including dialysis), COPD, Emphysema, ALS, Diabetic Coma/Insulin Shock, Amputation (caused by disease), Alzheimer's/Dementia?`,
	],
	NM: genericHealthQuestions,
	NV: genericHealthQuestions,
	NY: [],
	OH: withAdditionalClause(
		`have you been diagnosed as having AIDS or an AIDS-related condition or had a positive result on a HIV test?`
	),
	OK: genericHealthQuestions,
	OR: genericHealthQuestions,
	PA: genericHealthQuestions,
	RI: genericHealthQuestions,
	SC: genericHealthQuestions,
	SD: genericHealthQuestions,
	TN: genericHealthQuestions,
	TX: withAdditionalClause(
		`has any Proposed Insured ever tested positive for HIV or been diagnosed with ARC or AIDS or another condition derived from such infection?`
	),
	UT: genericHealthQuestions,
	VA: genericHealthQuestions,
	VT: withAdditionalClause(
		`within the past two (2) years have you been diagnosed, treated, or recommended for treatment for AIDS, ARC, or any other immune system disorder?`
	),
	WA: [
		// WA omits the first "terminal illness" question
		`Are you confined to a bed, hospitalized, scheduled for surgery requiring an overnight hospital stay, or receiving skilled nursing care;

		OR within the past two (2) years, have you had, been diagnosed with, or received treatment by a medical professional for stroke, organ transplant, cancer (other than skin), or immune system disorder;

		OR within the past one (1) year, have you had, been diagnosed with, or received treatment by a medical professional for COPD, emphysema, chronic heart disease, congestive heart failure, cirrhosis of the liver, kidney/renal failure, kidney dialysis, Alzheimer's disease, ALS (Amyotrophic Lateral Sclerosis), or amputation due to disease?`,
	],
	WI: genericHealthQuestions,
	WV: genericHealthQuestions,
	WY: genericHealthQuestions,
}

export function useHealthQuestions() {
	function getHealthQuestions(state: string | undefined): string[] {
		if (!state) return []
		return healthQuestions[state] ?? []
	}
	return { getHealthQuestions }
}
